export default {
  "content": "<rect x=\".399\" y=\"14.331\" width=\"20.267\" height=\"127.129\" rx=\"8\" transform=\"rotate(-45 .399 14.33)\" fill=\"#29967C\"/><rect x=\"11.948\" y=\"18.18\" width=\"20.267\" height=\"127.129\" rx=\"8\" transform=\"rotate(-45 11.948 18.18)\" fill=\"#68CBB3\"/><rect x=\"89.894\" width=\"20.267\" height=\"127.129\" rx=\"8\" transform=\"rotate(45 89.894 0)\" fill=\"#29967C\"/><rect x=\"101.443\" y=\"3.85\" width=\"20.267\" height=\"127.129\" rx=\"8\" transform=\"rotate(45 101.443 3.85)\" fill=\"#68CBB3\"/>",
  "attrs": {
    "width": "117",
    "height": "109",
    "viewBox": "0 0 117 109",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};